module.exports = __webpack_public_path__ + "static/img/10areaA_04.27a65f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/10areaA_04.png
// module id = 784
// module chunks = 1